import { render } from "./MrpHistory.vue?vue&type=template&id=4e413517&ts=true"
import script from "./MrpHistory.vue?vue&type=script&lang=ts"
export * from "./MrpHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__